import BpkImage, {
  withLazyLoading,
} from '@skyscanner-internal/backpack-web/bpk-component-image';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import currentLandingPagesOptions from '../../utils/richTextBrandStyles';
import RichText from '../RichText';
import { useMBDContext } from '../common/MBD/useMBDContext';

import ConfigurableLink from './ConfigurableLink';

import type { DestinationInfoCard as DestinationInfoCardProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationInfoCardsProps';

import STYLES from './DestinationInfoCard.module.scss';

type DestinationInfoCardWithIndexProps = DestinationInfoCardProps & {
  cardIndex: number;
};

const documentIfExists = typeof window !== 'undefined' ? document : null;
const LazyLoadedImage = withLazyLoading(BpkImage, documentIfExists);
const IMG_WIDTH = 392;
const IMG_HEIGHT = 184;

const DestinationInfoCard = ({
  cardIndex,
  description,
  image,
  links,
  title,
}: DestinationInfoCardWithIndexProps) => {
  const validLinks = links?.filter(({ link }) => link) ?? [];
  const { buildMBDParam, rawComponentName } = useMBDContext();
  const mbdComponentName = `${rawComponentName}_item`;

  return (
    <div
      className={STYLES.DestinationInfoCard}
      data-tracking-element-id={`${mbdComponentName}_${cardIndex}`}
      data-tracking-common-params={buildMBDParam(mbdComponentName)}
    >
      {image && (
        <div className={STYLES.DestinationInfoCard__image}>
          <LazyLoadedImage aspectRatio={IMG_WIDTH / IMG_HEIGHT} src={image} />
        </div>
      )}
      <BpkText tagName="h3" textStyle={TEXT_STYLES.heading4}>
        {title}
      </BpkText>

      {description && (
        <RichText body={description} options={currentLandingPagesOptions} />
      )}

      {validLinks.length > 0 && (
        <div className={STYLES.DestinationInfoCard__links}>
          {validLinks.map((link, linkIndex) => (
            <ConfigurableLink
              key={link.text}
              cardIndex={cardIndex}
              linkIndex={linkIndex}
              {...link}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default DestinationInfoCard;
